<template>
  <Modal title="新增上课要求" v-model="showModal" width="700" :mask-closable="false" @on-cancel="handleCancel" v-drag-modal>
    <div style="max-height: 60vh; overflow-y: auto; padding-right: 5px;">
      <Form ref="classRequirementForm" class="form" :model="formData" :rules="formRule">
        <Row>
          <Col :span="11">
            <Form-item label="学生信息">
              <label>{{ formData.uid }} - {{ formData.studentName }}</label>
            </Form-item>
          </Col>
          <Col :span="11" offset="2">
            <Form-item label="老师信息">
              <label>{{ formData.tchId }} - {{ formData.tchName }}</label>
            </Form-item>
          </Col>
        </Row>
        <Row>
          <Col :span="22">
            <div style="margin-bottom: 15px;">
              <span style="color: #999; font-size: 12px;">(外管审核后显示给老师)</span>
            </div>

            <!-- 一般需求 -->
            <div style="margin-bottom: 15px;">
              <h5 style="display: inline-block; margin: 0 10px 8px 0;">一般需求:</h5>
              <CheckboxGroup v-model="formData.classRequirementTags">
                <Checkbox label="活跃一些" style="margin-right: 10px;"><span>活跃一些</span></Checkbox>
                <Checkbox label="多微笑，不要太严肃" style="margin-right: 10px;"><span>多微笑，不要太严肃</span></Checkbox>
                <Checkbox label="纠音" style="margin-right: 10px;"><span>纠音</span></Checkbox>
                <Checkbox label="纠正错误表达" style="margin-right: 10px;"><span>纠正错误表达</span></Checkbox>
                <Checkbox label="引导多开口" style="margin-right: 10px;"><span>引导多开口</span></Checkbox>
                <Checkbox label="多些互动" style="margin-right: 10px;"><span>多些互动</span></Checkbox>
                <Checkbox label="引导整句输出" style="margin-right: 10px;"><span>引导整句输出</span></Checkbox>
                <Checkbox label="多鼓励孩子" style="margin-right: 10px;"><span>多鼓励孩子</span></Checkbox>
                <Checkbox label="多给些奖励" style="margin-right: 10px;"><span>多给些奖励</span></Checkbox>
              </CheckboxGroup>
            </div>

            <!-- 低级别上课需求 -->
            <div style="margin-bottom: 15px;">
              <h5 style="display: inline-block; margin: 0 10px 8px 0;">低级别上课需求:</h5>
              <CheckboxGroup v-model="formData.classRequirementTags">
                <Checkbox label="语速慢一点" style="margin-right: 10px;"><span>语速慢一点</span></Checkbox>
                <Checkbox label="多些 TPR" style="margin-right: 10px;"><span>多些 TPR</span></Checkbox>
                <Checkbox label="多些道具" style="margin-right: 10px;"><span>多些道具</span></Checkbox>
                <Checkbox label="课前互动简单一些最多3个问题" style="margin-right: 10px;"><span>课前互动简单一些最多3个问题</span></Checkbox>
                <Checkbox label="学生零基础，不要拓展" style="margin-right: 10px;"><span>学生零基础，不要拓展</span></Checkbox>
                <Checkbox label="减少拓展" style="margin-right: 10px;"><span>减少拓展</span></Checkbox>
              </CheckboxGroup>
            </div>

            <!-- 高级别上课需求 -->
            <div style="margin-bottom: 15px;">
              <h5 style="display: inline-block; margin: 0 10px 8px 0;">高级别上课需求:</h5>
              <CheckboxGroup v-model="formData.classRequirementTags">
                <Checkbox label="内容拓展" style="margin-right: 10px;"><span>内容拓展</span></Checkbox>
              </CheckboxGroup>
            </div>

            <!-- 自定义输入框 -->
            <div style="margin-top: 15px;">
              <Input name="classRequirement" v-model="formData.classRequirement" style="width: 100%;" type="textarea" :autosize="{ minRows: 2, maxRows: 10 }" placeholder="可额外输入其他上课要求，支持中文哦"></Input>
            </div>
          </Col>
        </Row>
      </Form>
    </div>
    <div slot="footer" style="text-align: center;">
      <Button type="primary" size="large" :loading="loading" @click="saveClassRequirement" style="width: 40%; margin: 0 10px;">保存</Button>
      <Button type="primary" size="large" @click="cancel" style="width: 40%; margin: 0 10px;">取消</Button>
    </div>
  </Modal>
</template>
<script>
export default {
  name: 'AddClassRequirementModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    uid: {
      type: [Number, String]
    },
    studentName: {
      type: String
    },
    tchId: {
      type: [Number]
    },
    bookLessonOpenedId: {
      type: [Number]
    },
    tchName: {
      type: String
    },
    classRequirement: {
      type: String,
      default: ''
    },
    classRequirementTags: {
      type: Array,
      default: () => []
    },
    successCallback: {
      type: Function
    }
  },
  data () {
    return {
      showModal: false,
      loading: false,
      formData: {
        uid: this.uid,
        studentName: this.studentName,
        tchId: this.tchId,
        tchName: this.tchName,
        classRequirement: this.classRequirement || '',
        classRequirementTags: this.classRequirementTags || []
      },
      formRule: {}
    }
  },
  watch: {
    value (val) {
      this.showModal = val
      if (val) {
        this.formData.uid = this.uid
        this.formData.studentName = this.studentName
        this.formData.tchId = this.tchId
        this.formData.bookLessonOpenedId = this.bookLessonOpenedId
        this.formData.tchName = this.tchName
        this.formData.classRequirement = this.classRequirement || ''
        this.formData.classRequirementTags = this.classRequirementTags || []
      } else {
        // 重置表单数据
        this.formData.classRequirement = ''
        this.formData.classRequirementTags = []
      }
    },
    uid (val) {
      this.formData.uid = val
    },
    studentName (val) {
      this.formData.studentName = val
    },
    tchId (val) {
      this.formData.tchId = val
    },
    tchName (val) {
      this.formData.tchName = val
    },
    bookLessonOpenedId (val) {
      this.formData.bookLessonOpenedId = val
    }
  },
  methods: {
    saveClassRequirement () {
      let self = this
      self.loading = true

      let req = {
        uid: self.formData.uid,
        classRequirement: self.formData.classRequirement,
        classRequirementTags: self.formData.classRequirementTags,
        tchId: self.formData.tchId,
        bookLessonOpenedId: self.formData.bookLessonOpenedId
      }

      self.$http.post('/stageReport/fm-message-demo-require-add', req, {
        transformRequest: [function (data, headers) {
          return JSON.stringify(data)
        }],
        headers: {'Content-Type': 'application/json;charset=utf-8'},
      }).then(function (res) {
        self.loading = false
        if (res) {
          self.$Message.success('保存成功!')
          // 先关闭本地对话框
          self.showModal = false
          // 然后通知父组件
          self.$emit('input', false)
          if (self.successCallback) {
            self.successCallback()
          }
          return
        }
      }).catch(function (e) {
        self.loading = false
      })
    },
    cancel () {
      // 先关闭本地对话框
      this.showModal = false
      // 然后通知父组件
      this.$emit('input', false)
    },
    handleCancel () {
      // 处理 Modal 右上角 X 关闭的情况
      this.showModal = false
      this.$emit('input', false)
    }
  }
}
</script>



// WEBPACK FOOTER //
// AddClassRequirementModal.vue?fc8931b2